import script from "./ComputeWizardQuality.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComputeWizardQuality.vue?vue&type=script&setup=true&lang=ts"

import "./ComputeWizardQuality.vue?vue&type=style&index=0&id=42bcefb5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42bcefb5"]])

export default __exports__